'use client'

import { useRef } from 'react'

import { createCircleOverlay, type CircleOverlay } from './overlay'
import { type TCoordinates } from '../../map-manager'

export const useCircleOverlay = () => {
  const circle = useRef<CircleOverlay | null>(null)
  const CircleOverlay = createCircleOverlay()

  const showCircle = ({ lat, lng }: TCoordinates) => {
    const latLng = new naver.maps.LatLng(lat, lng)

    circle.current = new CircleOverlay({
      position: latLng,
      fillColor: '#000',
    })
  }

  const hideCircle = () => {
    if (!circle.current) return

    circle.current.setMap(null)
    circle.current = null
  }

  return { showCircle, hideCircle }
}
